<template>
  <div class="row">
    <div class="col-md-3">
      <div class="card">
        <div class="card-body">
          <div class="form-group">
            <label>{{ $t("certificates.background_image") }}</label>
            <input
              type="file"
              name="image"
              accept="image/*"
              class="form-control load-image"
              @change="previewImage($event)"
            />
          </div>
          <hr />
          <div class="demo-inline-spacing">
            <b-form-radio
              v-model="data.type"
              name="some-radios"
              value="vertical"
            >
              {{ $t("certificates.vertical") }}
            </b-form-radio>
            <b-form-radio
              v-model="data.type"
              name="some-radios"
              value="horizontal"
            >
              {{ $t("certificates.horizontal") }}
            </b-form-radio>
          </div>
          <hr />
          <div class="demo-inline-spacing">
            <b-button
              variant="outline-primary"
              @click="setText('{{full_name}}')"
              class="col-5"
            >
              {{ $t("certificates.full_name") }}
            </b-button>
            <b-button
              variant="outline-primary"
              @click="setText('{{first_name}}')"
              class="col-5"
            >
              {{ $t("certificates.first_name") }}
            </b-button>
            <b-button
              variant="outline-primary"
              @click="setText('{{last_name}}')"
              class="col-5"
            >
              {{ $t("certificates.last_name") }}
            </b-button>
            <b-button
              variant="outline-primary"
              @click="setText('{{certification_date}}')"
              class="col-5"
            >
              {{ $t("certificates.certification_date") }}
            </b-button>
          </div>
          <hr />
          <ckeditor
            :config="{ contentsLangDirection: 'rtl',versionCheck : false }"
            id="input-4"
            v-model="content"
            ref="editor"
          >
          </ckeditor>
          <hr />

          <b-button variant="relief-dark" block @click="addtext" v-if="!edit">
            {{ $t("certificates.add_text") }}
          </b-button>
          <div class="row" v-else>
            <b-col md="6">
              <b-button variant="relief-primary" block @click="saveEdit()">
                {{ $t("site.save") }}
              </b-button>
            </b-col>
            <b-col md="6">
              <b-button variant="relief-danger" block @click="deleteItem()">
                {{ $t("site.delete") }}
              </b-button>
            </b-col>
          </div>
          <hr />
        </div>
        <!-- end of card body -->
      </div>
      <!-- end of card -->
    </div>
    <div class="col-md-9">
      <page
        size="A4"
        :layout="data.type"
        :style="{ 'background-image': 'url(' + url + ')' }"
      >
        <div class="card-body target" ref="target">
          <Moveable
            :data-index="index"
            v-for="(item, index) in data.text"
            :key="index"
            style="width: 200px"
            class="moveable"
            v-bind="moveable"
            @drag="handleDrag"
            @resize="handleResize"
            @scale="handleScale"
            @click="getText(item, index)"
          >
            <span v-html="item.text" :data-index="index"></span>
          </Moveable>
        </div>
      </page>

      <!-- end of card -->
    </div>
    <!-- end of col -->
  </div>
</template>
<script>
import Moveable from "vue-moveable";

export default {
  props: ["image",],
  components: {
    Moveable,
  },
  data: () => ({
    moveable: {
      width: 100,
      draggable: true,
      throttleDrag: 0,
      resizable: true,
      throttleResize: 1,
      scalable: true,
      throttleScale: 0,
      isDisplaySnapDigit: true,
      origin: true,
    },

    content: "",

    url: "",
    data: {
      type: "vertical",
      text: [],
    },
    edit: null,
  }),

  methods: {
    handleDrag({ target, transform }) {
      var rect = target.getBoundingClientRect();
      // if (rect.top - rectparent.top > maxtop) {
      target.style.transform = transform;
      // } else {
      // }
      let index = target.children[0].dataset.index;
      this.data.text[index].top = rect.top;
      this.data.text[index].left = rect.top;
    },
    getData() {
      return this.data;
    },
     setData(data) {
      return this.data=data;
    },
    handleResize({ target, width, height, delta }) {
      console.log("onResize", width, height);
      delta[0] && (target.style.width = `${width}px`);
      delta[1] && (target.style.height = `${height}px`);
      let index = target.children[0].dataset.index;
      this.data.text[index].width = width;
      this.data.text[index].height = height;
    },
    handleScale({ target, transform, scale }) {
      console.log("onScale scale", scale);
      target.style.transform = transform;
    },
    addtext() {
      this.data.text.push({ text: this.content, top: 0, left: 0 });

      this.content = "";
    },
    getText(item, index) {
      this.$set(this, "content", item.text);
      this.edit = { item, index };
    },
    saveEdit() {
      this.data.text[this.edit.index].text = this.content;
      this.edit = null;
      this.content = "";
    },
    deleteItem() {
      this.data.text.splice(this.edit.index, 1);
      this.edit = null;
      this.content = "";
    },
    setText(text) {
      this.$refs.editor.instance.insertText(text);
      // this.content += text;
    },

    previewImage(event) {
      const _file = event.target.files[0];

      this.data.image = _file;
      this.url = URL.createObjectURL(_file);
    },
  },
};
</script>
<style>
page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}
page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
  background-size: 21cm 29.7cm;
}
page[size="A4"][layout="horizontal"] {
  width: 29.7cm;
  height: 21cm;
  background-size: 29.7cm 21cm;
}
page[size="A3"] {
  width: 29.7cm;
  height: 42cm;
}
@media print {
  body,
  page {
    margin: 0;
    box-shadow: 0;
  }
}
</style>